import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { addNewPartner } from 'redux/actions/partners';

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    addNewPartner,
  }, dispatch),
});

export default connect(null, mapDispatchToProps);
